import axios from 'axios';
import getWeight from './getWeight';

const uShipEstimateHandler = async ({
	batch,
	location,
	address,
	coordinates,
	buyer,
}) => {
	try {
		let originPostalCode = '';
		let destinationPostalCode = '';
		let totalDeclaredValue = 0;
		let items = [];

		let dropAddress = {
			postCode: '',
			place: '',
			district: '',
			region: '',
			country: '',
		};
		let pickupAddress = {
			postCode: '',
			place: '',
			district: '',
			region: '',
			country: '',
		};

		if (batch?.listings[0]?.listing?.delivery?.location?.context) {
			for (let ob of batch?.listings[0]?.listing.delivery.location.context) {
				if (ob.id.includes('postcode')) {
					originPostalCode = ob.text;
					pickupAddress.postCode = ob.text;
				}
				if (ob.id.includes('place')) {
					pickupAddress.place = ob.text;
				}
				if (ob.id.includes('district')) {
					pickupAddress.district = ob.text;
				}
				if (ob.id.includes('region')) {
					pickupAddress.region = ob.short_code.slice(3);
				}
				if (ob.id.includes('country')) {
					pickupAddress.country = ob.short_code;
				}
			}
		}

		if (location?.context) {
			for (let ob of location.context) {
				if (ob.id.includes('postcode')) {
					destinationPostalCode = ob.text;
					dropAddress.postCode = ob.text;
				}
				if (ob.id.includes('place')) {
					dropAddress.place = ob.text;
				}
				if (ob.id.includes('district')) {
					dropAddress.district = ob.text;
				}
				if (ob.id.includes('region')) {
					dropAddress.region = ob.short_code.slice(3);
				}
				if (ob.id.includes('country')) {
					dropAddress.country = ob.short_code;
				}
			}
		}

		if (batch.listings.length > 0) {
			for (let box of batch.listings) {
				totalDeclaredValue = totalDeclaredValue + box.listingPrice;
				let weight;
				if (box.listing.weight || box.listing?.newSchema?.weight) {
					weight = box.listing.weight
						? box.listing.weight
						: box.listing?.newSchema?.weight
						? box.listing?.newSchema?.weight
						: '';
				} else {
					await getWeight(box.listing._id).then((i) => {
						weight = i;
					});
				}

				items.push({
					Title: box.listing.title?.slice(0, 49),
					Commodity: 'Furniture',
					widthInMeters: box.listing.measurements?.D
						? box.listing.measurements.D / 39.37 //inches to meter
						: 1, // default 1 Inch
					lengthInMeters: box.listing.measurements?.L
						? box.listing.measurements.L / 39.37
						: //inches to meter
						  1, // default 1 Inch
					heightInMeters: box.listing.measurements?.H
						? box.listing.measurements.H / 39.37
						: //inches to meter
						  1, // default 1 Inch
					weightInGrams: weight ? weight * 453.6 : 80 * 453.6,

					unitCount: 1,
					Description: box.listing.extraInfo
						?.replace(/\s*=\s*/g, ': ')
						?.replace(/&amp;/g, '&')
						?.replace(/\s*\n\s*/g, ' ')
						?.replace(/\s{2,}/g, ' ')
						?.trim()
						?.slice(0, 999),
				});
			}
		}

		let xssContent = batch.listings[0].listing.extraInfo;

		try {
			xssContent = xssContent
				?.replace(/\s*=\s*/g, ': ')
				?.replace(/&amp;/g, '&')
				?.replace(/\s*\n\s*/g, ' ')
				?.replace(/\s{2,}/g, ' ')
				?.trim();
		} catch (e) {}

		let uShipDeliveryBody = {
			title: batch.listings[0].listing.title?.slice(0, 49),
			description: xssContent?.slice(0, 999),
			route: {
				items: [
					{
						address: {
							streetAddress: batch.listings[0].listing.delivery.address,
							alternateStreetAddress:
								batch.listings[0].listing.delivery.address,
							majorMunicipality: pickupAddress.district,
							postalCode: pickupAddress.postCode,
							stateProvince: pickupAddress.region,
							country: pickupAddress.country,
							longitude: batch.listings[0].listing.delivery.location.center[0],
							latitude: batch.listings[0].listing.delivery.location.center[1],
							type: batch.author?.isBusiness
								? 'BusinessWithLoadingDockOrForklift'
								: 'Residence',
							timeZone: '',
						},
						timeFrame: {
							earliestArrival: '',
							latestArrival: '',
							timeFrameType: 'between',
						},
						contact: {
							name: batch.author?.firstName ? batch.author?.firstName : 'Pinko',
							companyName: 'Kashew',
							phoneNumber: batch.author.phone,
							email: batch.author.email,
							firstName: batch.author.firstName,
							lastName: batch.author.lastName,
						},
					},
					{
						address: {
							streetAddress: address,
							majorMunicipality: dropAddress.district,
							postalCode: dropAddress.postCode,
							stateProvince: dropAddress.region,
							country: dropAddress.country,
							longitude: coordinates[0],
							latitude: coordinates[1],
							type: 'Residence',
							timeFrame: '',
						},
						timeFrame: {
							earliestArrival: '',
							latestArrival: '',
							timeFrameType: 'between',
						},
						contact: {
							name: buyer?.firstName ? buyer.firstName : 'Test123',
							companyName: '',
							phoneNumber: buyer?.phone ? buyer.phone : 'Test123',
							email: buyer?.email ? buyer.email : 'Test123',
							firstName: buyer?.firstName ? buyer.firstName : 'Test123',
							lastName: buyer?.lastName ? buyer.lastName : 'Test123',
						},
					},
				],
			},
			pricing: {
				namedPrice: {
					amount: '',
					currencyType: 'USD',
				},
			},
			insurance: {
				coverageAmount: {
					amount: totalDeclaredValue,
					currencyType: 'USD',
					commodity: 'Furniture',
				},
			},
			items,
			attributes: {
				crated: false,
				stackable: false,
				palletized: false,
			},
			serviceTypes: ['BlanketWrap'],
			referenceNumbers: [
				{
					number: '',
					type: 10, //don't change type text, 10 designates price correlation id
				},
			],
		};

		let body = {
			source: 'kashew.com',
			originPostalCode,
			destinationPostalCode,
			items: items,
			commodity: 'Furniture',
			originCountryCode: 'US',
			destinationCountryCode: 'US',
			// insurance: {
			// 	coverageAmount: {
			// 		amount: totalDeclaredValue,
			// 		currencyType: 'USD',
			// 		commodity: 'Furniture',
			// 	},
			// },
		};

		return await axios
			.post(`${process.env.NEXT_PUBLIC_SERVER_API}/api/orders/uShipRate`, {
				...body,
			})
			.then((res) => {
				// let finalPrice =
				// 	res.data.price > 250 ? res.data.price * 0.5 : res.data.price;
				let finalPrice = res.data.price;

				uShipDeliveryBody.pricing.namedPrice.amount = finalPrice;

				uShipDeliveryBody.referenceNumbers[0].number =
					res.data.priceCorrelationId;

				return {
					priceDetails: {
						...res.data,
						// price: finalPrice * 1.125,
						price: finalPrice * 1.4,
						// price: finalPrice + res.data.insurance.premium.amount,
						// price: finalPrice * 1.125 + res.data.insurance.premium.amount,
					},
					uShipDeliveryBody,
				};
			})
			.catch((error) => {
				console.log(error);
				return null;
			});
	} catch (error) {
		console.log(error);
		return error;
	}
};
export default uShipEstimateHandler;
